import { Skeleton } from '@/ui/components/primitives/skeleton'
import { cn } from '@/shared/utils'

const SIDEBAR_WIDTH = 320

function SidebarTripItemSkeleton() {
  return (
    <div className="flex flex-col rounded-md overflow-hidden">
      <Skeleton className="w-full aspect-[3/1] min-h-[52px] rounded-t-md" />
      <div className="p-2 space-y-1.5 bg-earth-50 border border-t-0 border-earth-200 rounded-b-md">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  )
}

export interface TripsSidebarSkeletonProps {
  className?: string
}

export function TripsSidebarSkeleton({ className }: TripsSidebarSkeletonProps) {
  return (
    <aside
      className={cn(
        'hidden md:flex flex-col flex-shrink-0 h-full overflow-hidden border-r border-earth-200 bg-earth-50',
        className
      )}
      style={{ width: SIDEBAR_WIDTH }}
      aria-label="Trips sidebar loading"
    >
      <div className="flex flex-col h-full min-h-0 overflow-hidden">
        <div className="p-4 border-b border-earth-200">
          <div className="flex items-center justify-between mb-4">
            <Skeleton className="h-6 w-16" />
            <div className="flex gap-1">
              <Skeleton className="h-8 w-8 rounded-md" />
              <Skeleton className="h-8 w-8 rounded-md" />
            </div>
          </div>
          <Skeleton className="h-9 w-full rounded-md" />
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto p-2 space-y-6">
          {[1, 2, 3].map((group) => (
            <div key={group}>
              <div className="flex items-center gap-2 px-2 py-1.5">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-6" />
              </div>
              <div className="mt-1 space-y-2">
                <SidebarTripItemSkeleton />
                <SidebarTripItemSkeleton />
                <SidebarTripItemSkeleton />
              </div>
            </div>
          ))}
        </div>
      </div>
    </aside>
  )
}
